import styled from 'styled-components'

export const ContainerTemplate = styled.div`
  background-color: var(--app-background-desktop);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-padding-large) var(--spacing-padding-large)
    var(--spacing-padding-large);
  -webkit-box-flex: 1;
  flex-grow: 1;
  @media screen and (max-width: 576px) {
    background-color: var(--app-background-mobile);
  }
`

export const ItemTemplate = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`
